import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BaseSignalRService } from './base-signalr.service';

@Injectable({
  providedIn: 'root'
})
export class SaleApprovalsSignalRService extends BaseSignalRService {
  private readonly saleApprovedSubject = new BehaviorSubject<string>('');

  public saleApproved$ = this.saleApprovedSubject.asObservable();

  protected getHubUrl(): string {
    return `${this.apiUrl}/saleApprovalsHub`;
  }

  protected setupEventHandlers(): void {
    if (!this.hubConnection) {
      return;
    }

    this.hubConnection.on('SaleApproved', (opportunityId: string | { value: string; }) => {
      const id = typeof opportunityId === 'string' ? opportunityId : opportunityId.value;
      this.saleApprovedSubject.next(id);
    });

    this.setupConnectionStateHandlers();
  }
}
